module.exports = __webpack_public_path__ + "assets/media/1.9b91e888.ogg";